import * as React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import Modal from '../../common/modal'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import { updateModal } from '../../../store/common/common_action'
import { focusElemnt, getInt, getIntWithoutLeadingZero, lineInputNavigation2, randomString } from '../../common/helper'
import { Pickup, collCartageBrkupKeyArr } from '../../common/constants'
import { updatePriceSectionRowData, updatePriceSectData } from '../../../store/booking/booking_action'
import LineInputV2 from '../../common/lineinputV2'
import { STA_COMPANY_ID } from '../../../helper/companyIdhardcode'

const CollCartageUI = (props) => {
  const { data, updatePriceSectData, handleAlert } = { ...props }
  const { booking: bookingL,common } = data
  const { loginData } = common
  const { intCompanyID } = loginData
  let { priceSectionData } = { ...bookingL }
  const [priceSecDataL, setPriceSecDataL] = useState({ ...priceSectionData })

  const handleChange = (e, type) => {
    if (+e.target.value + +priceSectionData.del_cartage > priceSectionData.freight * 2 && intCompanyID === STA_COMPANY_ID) {
      return handleAlert('Pickup and delivery cartage should not be greater than twice the freight', `CCBrkup_pckp`)
    }
    if (e.target.value.match(/^\d*\.?\d*$/)) setPriceSecDataL({ ...priceSecDataL, [type]: e.target.value })
  }

  const totalWt = () => {
    let totalWt = collCartageBrkupKeyArr.reduce((p, c) => p + parseFloat(priceSecDataL[c.id] || 0), 0)
    return totalWt.toFixed(2)
  }
  function cf(x) {
    //convert to float
    var floatValue = +x
    return floatValue
  }
  return (
    <Modal
      headTxt={`Cartage Breakup`}
      width={'30%'}
      updateModal={(e) => {
        setPriceSecDataL({ ...priceSectionData })
        props.callFromAdmin ? props.setCollCartageModal(false) : props.updateModal()
      }}
    >
      <Stack direction="column" sx={{ padding: '15px 0px' }}>
        <div style={{ width: '100%', padding: '0px 15px', position: 'relative' }}>
          <div
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: 'space-between',
            }}
            ref={props?.inputRef}
          >
            {collCartageBrkupKeyArr.map(({ id, lbl, nextID, prevID }, ind) => (
              <Box
                key={`coll_crtge_lnIp_${id}_`}
                sx={{
                  width: '99%',
                  display: 'inline-flex',
                  padding: '0% 0px',
                }}
              >
                <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                  <LineInputV2
                    id={id}
                    type={`number`}
                    name={id}
                    label={lbl}
                    value={priceSecDataL[id]}
                    filter={getIntWithoutLeadingZero}
                    onBlur={(e) => {
                      handleChange(e, id)
                    }}
                    onKeyDown={(e) => {
                    if(e.key === 'Escape' && lbl==Pickup ){
                      props.callFromAdmin ? props.setCollCartageModal(false) : props.updateModal()
                    };lineInputNavigation2(e, nextID, prevID)
                    }}
                    
                  />
                </div>
              </Box>
            ))}
          </div>
        </div>
        <Box
          sx={{
            padding: '15px',
            display: 'flex',
            justifyContent: 'center',
            color: `#444`,
            background: `#e5f3fa`,
            marginBottom: '30px',
          }}
        >
          Total: {totalWt()}
        </Box>
        <Box sx={{ width: '100%', padding: '12px 15px' }}>
          <Button
            variant="contained"
            id={`saveCartageBreakupButton`}
            onClick={(e) => {
              const { CCBrkup_pckp, CCBrkup_cmsn, CCBrkup_rtrn } = {
                ...priceSecDataL,
              }
              updatePriceSectionRowData({
                ...priceSectionData,
                coll_cartage: totalWt(),
                CCBrkup_pckp,
                CCBrkup_cmsn,
                CCBrkup_rtrn,
              })
              setPriceSecDataL({
                ...priceSectionData,
                coll_cartage: totalWt(),
                CCBrkup_pckp,
                CCBrkup_cmsn,
                CCBrkup_rtrn,
              })
              updatePriceSectData('coll_cartage', cf(totalWt()))
              updatePriceSectData('CCBrkup_pckp', Number(CCBrkup_pckp))
              updatePriceSectData('CCBrkup_cmsn', Number(CCBrkup_cmsn))
              updatePriceSectData('CCBrkup_rtrn', Number(CCBrkup_rtrn))
              //  props.updateModal()
              props.callFromAdmin ? props.setCollCartageModal(false) : props.updateModal()
              focusElemnt('del_cartage')
            }}
            className="btn btn-primary"
            sx={{
              width: '100%',
              padding: '10px',
              letterSpacing: '2px',
            }}
          >
            SAVE
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateModal, updatePriceSectionRowData, updatePriceSectData }
export default connect(mapStateToProps, mapDispatchToProps)(CollCartageUI)
